module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fwmw0"))).then(() => parcelRequire('1iHdE'));